import { useEffect, useState, useCallback } from "react";
import PageTitle from "../../components/common/PageTitle";
import useQueryParams from "../../hooks/useQueryParams";
import AppNotificationTemplates from "./Marketing/AppNotificationTemplates";
import { useNavigate } from "react-router-dom";
import AppNotificationHistory from "./Marketing/AppNotificationHistory";

const Marketing = () => {
  const { updateQueryParam, queryParams } = useQueryParams();
  const navigate = useNavigate();
  const tab = queryParams.get("tab") || "app";
  const section = queryParams.get("section") || "history";
  const groupid = queryParams.get("groupid") || "";
  useEffect(() => {
    if (!tab) {
      navigate(-1);
    }
  }, [tab]);
  useEffect(() => {
    if (groupid) {
      navigate("/marketing/notification?tab=app&section=history&groupid=" + groupid);
    } 
  }, [groupid]);

  const UpdateParams = (key, value) => {
    updateQueryParam(key, value);
    updateQueryParam("pageSize");
    updateQueryParam("pageNo");
    updateQueryParam("groupid");
  };
  return (
    <section className="pos-rel">
      <PageTitle title="Marketing" />
      <div
        className="flex"
        style={{ minHeight: "80vh", flexDirection: "column" }}
      >
        {tab && (
          <>
            <div
              className="rs-tabs flex "
              style={{
                gap: "15px",
                justifyContent: "space-between",
                borderBottom: "1px solid #e5e5e5",
              }}
            >
              {/* <ul className="tab-selector">
                 <li
                  className={tab === "email" ? "active" : ""}
                  onClick={() => {
                    UpdateParams("tab", "email");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <h6>Email</h6>
                </li> 
                <li
                  className={tab === "app" ? "active" : ""}
                  onClick={() => {
                    UpdateParams("tab", "app");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <h6>App Push Noification</h6>
                </li>
              </ul> */}
            </div>
            {tab === "app" && (
              <div className="results">
                <div
                  className="rs-tabs flex"
                  style={{
                    gap: "15px",
                    margin: "10px 20px",
                    justifyContent: "space-between",
                  }}
                >
                  <ul className="tab-selector">
                    <li
                      className={section === "history" ? "active" : ""}
                      onClick={() => {
                        UpdateParams("section", "history");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <h6>History</h6>
                    </li>
                    <li
                      className={section === "template" ? "active" : ""}
                      onClick={() => {
                        UpdateParams("section", "template");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <h6>Template</h6>
                    </li>
                  </ul>
                </div>

                {tab === "app" && section === "template" ? (
                  <AppNotificationTemplates />
                ) : (
                  <AppNotificationHistory />
                )}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Marketing;
